(function () {
    'use strict';
  
    /* @ngdoc object
     * @name complaints
     * @description
     *
     */
    angular
      .module('complaints', [
        'messages',
        'ui.router'
      ]);
  }());
  